module.exports = __webpack_public_path__ + "img/What-is-ai-en.5a987de.png";